<template>
  <learn-layout>
    <template v-slot:content>
      <v-col :cols="12" class="text-h6" style="color: black;">
        Branding Profile
      </v-col>
      <v-col :cols="12">
        Setup your branding profile so that your branded Torvue links will show a photo of you, your name, phone number, and email address.  Watch the video below to see how.
      </v-col>
      <v-col :cols="12">
        <div class="text-h6">Video Guide</div>
        <div class="embed-youtube">
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/OCCnxIZSQI8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </v-col>
      <v-col :cols="12">
        <div class="text-h6">Steps</div>
        <ol>
          <li>Go to the <router-link to="/branding" target="_blank">branding</router-link> page.</li>
          <li>
            Upload a photo.
          </li>
          <li>Set your name, phone number, and email.</li>
          <li>Click Submit</li>
        </ol>
      </v-col>
    </template>
    <template v-slot:footer>
      <v-spacer />
      <div>
        <div class="caption font-italic">Next step:</div>
        <v-btn class="float-end" color="primary" to="/learn/unbox" :small="$vuetify.breakpoint.smAndDown">
          Setup camera
          <v-icon class="pl-2">mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </template>
  </learn-layout>
</template>

<script>
import LearnLayout from "@/components/LearnLayout.vue";

export default {
  name: "LearnBranding",
  components: {LearnLayout}
}
</script>

<style scoped>

</style>